export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m@3x.d664f4e0.webp";